
import Vue from "vue";
import SolicitudArrendamientoService from '@/services/SolicitudArrendamientoService';
import  cesionDerechosService  from "@/services/cesionDerechosService";
import {mapGetters} from "vuex";
import CustomFile from "@/components/Common/CustomFile.vue";
import { _cesionDerecho, cesionDerecho } from "@/models/cesionDerecho";
import FormCreate from "@/components/Solicitudes/FormCesionDerecho.vue";
import { CatalogoService } from "@/services/CatalogoService";
import EstablecimientoService from '@/services/EstablecimientoService';

export default Vue.extend({
    name: "Establecimientos",
    mixins: [],
    components: {CustomFile,FormCreate
    },
    directives: {},
    data: () => ({
      listEstatus: [
      {
        id:1,
        descripcion:"INICIO"
      },
      {
        id:3,
        descripcion:"VALIDADA"
      },
      {
        id:10,
        descripcion:"EN PROCESO"
      },
      {
        id:4,
        descripcion:"FINALIZADA"
      }
    ],
    documentoview: Document || null,
     dialogPdfView:false,
      showInputPagoSolid:false,
      dialogsubirdoc:false,
      dialogCreateContrato: false,
      servicio:new CatalogoService('cesionDerechoExterno'),
      element: new cesionDerecho(),
      dialogCreate: false,
      filters: {
            page: 1,
            external_id: "",
            nombre_comercial: "",
            id_estatus:0,
            per_page: 10,
        },
        pagination: {
            from: 1,
            last_page: 1,
        },
        list: [],
    }),
    mounted() {
        this.getData();
    },
    computed: {
        ...mapGetters({
            usuario: "usuario",
            id: "id",
            contribuyente: "contribuyente",
            mini: "sidebar",
        }),
    },
    watch: {
        "filters.page": function () {
            this.getData();
            //this.saveFilters();
        },
    },
    methods: {
      openDialogPagoSolid(item: any){
          this.element = item;
          this.dialogsubirdoc = true;
          if(item.id_recibo_pago > 0){
            this.showInputPagoSolid = false;
          }
        },
      async viewpdf(item: any, tipo:any,id:any,titulo:any) {
        const response = await EstablecimientoService.descargarFormato(`documentacion/${id}`,{},'GET','Temp');

        let file = new Blob([response.data],{type: response.headers['content-type']});
        const url = window.URL.createObjectURL(file);
          this.documentoview = {
            //@ts-ignore
            title: titulo,
            url: url,
            mime: response.headers['content-type'],
            tipo: tipo,
            datos:item
        }
        this.dialogPdfView=true;
    },
      closeDialogAutorizacion() {
          this.dialogsubirdoc = false;
        },
        subirDocPago(item:any){
          var valor = 0;
          if(item.id_recibo_pago >0){
            valor = item.id_recibo_pago;
          }
          let data = {
            docSolidPago: item.docSolidPago,
            id_recibo_pago: valor
            };
            cesionDerechosService.subirArchivoSolidPago(item.id, data)
                .then((response) => {
                    if (response.data.success) {
                        this.$toast.success(response.data.message);
                        this.closeDialogAutorizacion();
                        this.getData();
                    } else {
                        this.$toast.error(response.data.message);
                    }
                })
                .catch((error) => {
                    this.$toast.error("No se pudo guardar el archivo.")
                })
        },
        aprovarInfo(item: any) {
        cesionDerechosService.aprovarSolicitud(item.id)
                .then((response) => {
                    if (response.data.success) {
                        this.$toast.success(response.data.message);
                        this.getData();
                    } else {
                        this.$toast.error(response.data.message);
                    }
                })
                .catch((error) => {
                    this.$toast.error("No se pudo enviar la solicitud.")
                })
      },
      setDocument(e: any, type: number) {
            const fileReader = new FileReader();
            fileReader.addEventListener("load", () => {
                var file = fileReader.result;
                if (type == 1)
                //@ts-ignore
                this.element.docSolidPago = file + "";
        });
        if (e != null)
        fileReader.readAsDataURL(e);
        },
        cancelChangeFile(file: any) {
      if (file == 1)
        this.showInputPagoSolid = false;
    },
    changeFile(file: any) {
        if (file == 1)
        this.showInputPagoSolid = true;
    },
      clearFilters() {
      this.filters = {
        page: 1,
        id_estatus: 0,
        nombre_comercial: '',
        external_id: '',
        per_page: 10
      }
      this.getData();
    },
      setEstatus(){
      this.filters = {
        ...this.filters,
        id_estatus: this.listEstatus.find((item: any) => item.id == this.filters.id_estatus)!.id
      }
    },
        async getData() {
            if (!this.filters.page) {
                this.filters.page = 1;
            }

        if (this.filters.external_id || this.filters.nombre_comercial) {
            this.filters.page = 1;
        }
        if (!this.filters.external_id && !this.filters.nombre_comercial) {
            this.filters.external_id = "";
            this.filters.nombre_comercial = "";
        }

        const { data } = await cesionDerechosService.getallsolicitudes(this.contribuyente.id, this.filters);
                
        this.pagination = {
        from: data.from,
        last_page: data.last_page
            }
               this.list = data.data;
        },
        newItem() {
        this.element = Object.assign({});
        this.dialogCreate = true;
      },
      editar(item: any) {
        this.element = Object.assign({}, item);
        this.element.locacion = item.local_mercado.locacion.id;
        this.element.rfc = item.cesionario.rfc;
        this.dialogCreate = true;
      },
      closeDialogCreate(reload:boolean){
          this.dialogCreate = false;
      if(reload)
        this.getData();
      },
    },
});
